<div class="modal-header">
  <h5 class="modal-title">{{ title }} </h5>
  <button type="button" class="close" aria-label="Close" (click)="cancel('X')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="recipientForm" novalidate>
    <div class="form-group col-12">
      <div class="form-group form-group-sm" [class.has-danger]="(recipientForm.get('recipient').hasError('required') || recipientForm.get('recipient').hasError('multipleEmails')) && recipientForm.get('recipient').touched">
        <label>{{ recipientMessage }} </label>
        <input class="form-control" id="recipient" formControlName="recipient">
        <span class="form-control-feedback" *ngIf="recipientForm.get('recipient').hasError('required') && recipientForm.get('recipient').touched">
          <small class="form-text">{{ 'EmailRequired' | translate }}</small>
        </span>
        <span class="form-control-feedback" *ngIf="recipientForm.get('recipient').hasError('multipleEmails') && recipientForm.get('recipient').touched">
          <small class="form-text">{{ 'EmailInvalid' | translate }}</small>
        </span>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <div class="text-right">
    <button class="btn btn-primary" (click)="send()">{{ 'PreviewNotification' | translate }}</button>
    <button class="btn" (click)="cancel('')">{{ 'Cancel' | translate }}</button>
  </div>
</div>
